module.exports = __webpack_public_path__ + "static/media/avatar.3b546b53.jpg";